import type { GameId } from '@xox/shared'
import type { ArcadeTone } from '../components/ui'

/** Each house bot's look: card gradient, glow, accents and its RobotFace palette class. */
export interface BossTheme {
  hero: string
  ring: string
  glow: string
  eyebrow: string
  sub: string
  arcade: ArcadeTone
  /** CSS class scoping the `--robot-*` palette overrides (see index.css). */
  robot: string
  /** Text color for accents on light cards (spotlights, pills). */
  accent: string
  accentBg: string
  /** Progress bar fill on the wall. */
  bar: string
}

export const BOSS_THEME: Record<GameId, BossTheme> = {
  xox: {
    hero: 'bg-[linear-gradient(135deg,var(--boss-bg-1),var(--boss-bg-2))]',
    ring: 'ring-violet-500/40',
    glow: 'bg-[var(--robot-eye)]',
    eyebrow: 'text-violet-300',
    sub: 'text-violet-200',
    arcade: 'boss',
    robot: '',
    accent: 'text-violet-600 dark:text-violet-400',
    accentBg: 'bg-violet-100 text-violet-700 dark:bg-violet-950/60 dark:text-violet-300',
    bar: 'bg-[linear-gradient(90deg,var(--arcade-boss-1),var(--arcade-boss-2))]',
  },
  c4: {
    hero: 'bg-[linear-gradient(135deg,var(--boss-c4-bg-1),var(--boss-c4-bg-2))]',
    ring: 'ring-amber-400/40',
    glow: 'bg-[var(--robot-c4-eye)]',
    eyebrow: 'text-amber-300',
    sub: 'text-amber-100/80',
    arcade: 'drop',
    robot: 'robot-c4',
    accent: 'text-amber-700 dark:text-amber-300',
    accentBg: 'bg-amber-100 text-amber-800 dark:bg-amber-950/60 dark:text-amber-200',
    bar: 'bg-[linear-gradient(90deg,var(--arcade-drop-1),var(--arcade-drop-2))]',
  },
}
